import { useTranslation } from '@web_opxp/features';
import { useDispatch } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { trackGoToBlogButton } from './firebaseActions';

import { useDoubleClickProtection } from '@web_opxp/components';
import './BlogPreview.scss';

export interface IBlogPreviewProps {
  title: string;
  imageUrl: string;
  content: string;
  articleUrl: string;
}

export default function BlogPreview({ title, imageUrl, content, articleUrl }: Readonly<IBlogPreviewProps>) {
  const { t } = useTranslation();

  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const clickHandler = () => {
    dispatch(trackGoToBlogButton());
  };
  const onClickHandler = useDoubleClickProtection(clickHandler);
  return (
    <div className="blog-preview">
      <h2 className="blog-preview-title">{title}</h2>
      <div className="blog-preview-image-wrapper">
        <img className="blog-preview-image" src={imageUrl} alt={title} />
      </div>
      <p className="blog-preview-description">{content}</p>
      <a
        className="blog-preview-cta"
        href={articleUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClickHandler}>
        {t('Dashboard.BlogPreview.LinkLabel')}
      </a>
    </div>
  );
}
